import React from 'react';
import { Title, TextInput, SelectInput, /*useNotify,*/ useTranslate, useAuthenticated, required } from 'react-admin';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';

import SimpleForm from './common/forms/SimpleForm';

// import { createTicket } from '../../services/api';


const Support = () => {
    // const notify = useNotify();
    const translate = useTranslate();
    useAuthenticated();

    const types = [
		// { id: '', name: translate('') }
	];

    const handleSubmit = async (data) => {
        // let formData = {
        //     type: data?.type,
        //     description: data?.description
        // };

        // const response = await createTicket(formData);
        // if (response.success) {
        //     notify(translate('Ticket added'));
        // }
    };

    return (
        <Box my={3}>
            <Card>
                <Title title={translate('Support')} />
                <SimpleForm onSubmit={handleSubmit}>
                    <>
                        <Typography variant="h6">{translate('You have a problem on our platform?')}</Typography>
                        <Typography variant="h6" sx={{ marginBottom: '15px' }}>{translate('Report your issue')}</Typography>
                    </>

                    <SelectInput label="Type" source="type" choices={types} validate={required()} />
                    <TextInput label="Description" source="description" multiline rows="4" validate={required()} />
                </SimpleForm>
            </Card>
        </Box>
    );
};

export default Support;